<template>

    <v-container v-if="desserts" class="view-info" :class="edicion ? 'view-info-edit' : ''">
      <v-chip class="mb-3" v-if="desserts.fechainiprevista" label >
        <v-icon left>av_timer</v-icon>{{ formatDate( desserts.fechainiprevista) }} <span v-if="desserts.fechafinprevista">&nbsp;&nbsp;&nbsp;->&nbsp;&nbsp;&nbsp;</span> {{formatDate(desserts.fechafinprevista)}}
      </v-chip>

      <h3>{{desserts.tipo}}</h3>

      <div class="text">
        <v-btn 
          v-if="!edicion" 
          @click="edicion = !edicion" 
          color="primary" 
          class="mb-3">
          <v-icon left>edit</v-icon>Editar
        </v-btn>
      
        <v-btn
            v-if="edicion"
            @click="updateDesserts()"
            color="success"
            class="ma-2"
            >
            <v-icon left>save</v-icon>
            Guardar
        </v-btn>

     <!-- boton cancelar vuejs-->
      <v-btn
          v-if="edicion"
          @click="$router.go(0)"
          color="error"
          class="ma-2"
          >
          <v-icon left>cancel</v-icon>
          Cancelar
      </v-btn>

      <div class="mt-2"><b>CLIENTE: </b>{{desserts.nombrecli}} {{desserts.apellidoscli}} <span v-if="desserts.nombrecomercial">({{desserts.nombrecomercial}})</span></div>
      <div v-if="desserts.nombretecnico!='' && desserts.nombretecnico!=null"><b>TECNICO: </b>{{desserts.nombretecnico}} {{desserts.apellidostecnico}}</div>
      <div v-if="desserts.nombreagente!='' && desserts.nombreagente!=null"><b>AGENTE: </b>{{desserts.nombreagente}} {{desserts.apellidosagente}} <span v-if="desserts.porcomision">(comisión {{desserts.porcomision}}%)</span></div>

      <div><input  type="checkbox" id="checkbox" v-model="desserts.contratomant" true-value="t" false-value="f" :disabled="!edicion"> Contrato de mantenimiento</div>

      <div><input  type="checkbox" id="checkbox" v-model="desserts.presupuesto" true-value="t" false-value="f" :disabled="!edicion"> Presupuesto</div>

          <!-- <p class="desccorta" text-color="white">{{desserts.descripcioncorta}}</p> -->

          <br><b>DESCRIPCIÓN: </b><br>
          <p v-if="desserts.descripcion && edicion == false" class="desclarga" stylw='font-size:8px;' text-color="white"> {{desserts.descripcion}} </p>
          <textarea class="edicion" v-if="edicion" v-model="desserts.descripcion" placeholder="Inserta a descripcion"></textarea>

          <b>SOLUCIÓN: </b><br>
          <p v-if="desserts.solucion && edicion == false">{{desserts.solucion}}</p>
          <textarea class="edicion" v-if="edicion" v-model="desserts.solucion" placeholder="Inserta a solucion"></textarea>

          <b>OBSERVACIONES: </b><br>
          <p v-if="desserts.observaciones && edicion == false">{{desserts.observaciones}}</p>
          <textarea class="edicion" v-if="edicion" v-model="desserts.observaciones" placeholder="Inserta a observaciones"></textarea>
      </div>
      <!-- boton aceptar en vuejs -->
      <v-btn
          v-if="edicion"
          @click="updateDesserts()"
          color="success"
          class="ma-2"
          >
          <v-icon left>save</v-icon>
          Guardar
      </v-btn>
      
      <!-- boton cancelar vuejs-->
      <v-btn
          v-if="edicion"
          @click="$router.go(0)"
          color="error"
          class="ma-2"
          >
          <v-icon left>cancel</v-icon>
          Cancelar
      </v-btn>

      <div class="pryectos" v-if="desserts.codproyecto">
          <div class="proyecto">  <h3>Proyecto: {{desserts.codproyecto}} </h3> </div>
          <div v-if="desserts.descripcion" class="presupuestos"> Descripción: {{desserts.descripcion}}</div>

      </div>

      <div class="presupuestos" v-if="desserts.codigo">
          <div class="presupuestos">  <h3>Presupuesto: {{desserts.codigo}} </h3> </div>
          <div v-if="desserts.titulo" class="presupuestos"> Titulo: {{desserts.titulo}}</div>
          <!-- <div v-if="desserts.notas" class="presupuestos"> Notas: {{desserts.notas}}</div> -->
      </div>

      <v-card style="padding:10px 20px 20px 20px;">
            <!-- <v-textarea
              clearable
              v-model="observaciones"
              auto-grow
              rows="2"
              clear-icon="cancel"
              v-bind:label="$t('prealbaran_observaciones')"
              onkeyup="javascript:this.value=this.value.toUpperCase();"
            ></v-textarea> -->

        <div class="optionsfirma">
          <v-switch v-model="checkboxfirmarprealbaran" :label="`Firmar Servicio`" hide-details :disabled="checkboxfirmarprealbaran_disabled"></v-switch>
          <v-switch v-model="checkboxenviaremail" :label="`Enviar email`" hide-details :disabled="checkboxenviaremail_disabled"></v-switch>
          <!--<v-text-field v-if="checkboxenviaremail" class="textemail" v-model="desserts.emails" ref="email" label="Email" outlined clearable dense hide-details ></v-text-field>-->
          <AddEmail v-if="checkboxenviaremail" v-bind:objects="email_list" />
        </div>

        <div v-if="checkboxfirmarprealbaran"><Firma v-bind:text="'FIRMAR Y CERRAR SERVICIO'" /></div>
        <div v-else> <button @click="dialogVerificacionAlbaran=true" class="buttoncreate"><v-icon class='icon' style="">create</v-icon>CERRAR SERVICIO</button></div>
      </v-card>

      <v-dialog v-model="dialogVerificacionAlbaran" max-width="400">
        <v-card>
        <v-card-title class="headline">CERRAR SERVICIO</v-card-title>
          <v-card-text>
            <div class="mb-1" style="color:#bd0808;" v-if="checkboxenviaremail && desserts.email==''"><b>Atención!</b> no se ha especificado <b>email</b>!</div>
            <!-- <div class="mb-1" style="color:#bd0808;" v-if="observaciones==''"><b>Atención!</b> no hay <b>observaciones</b>!</div> -->
            <div class="mb-1" style="color:#bd0808;" v-if="checkboxfirmarprealbaran && firma.nombrefirmante==''"><b>Atención!</b> sin <b>Nombre firmante</b>!</div>
            <div v-if="checkboxenviaremail && desserts.email && desserts.email!=''"><b>Enviar a:</b><br> {{desserts.email.split(";").join(" ")}}</div>
            <div v-if="!checkboxfirmarprealbaran">Finalizar parte sin firma</div>
            <div v-if="!checkboxenviaremail">Finalizar parte sin enviar por email</div>

          </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#555555" text @click="dialogVerificacionAlbaran=false">Cancelar</v-btn>
            <v-btn color="#555555" text @click="crearalbaranfromprealbaran()">Crear</v-btn>
        </v-card-actions>
        </v-card>
    </v-dialog>
    </v-container>
</template>

<script>
import { gw } from "@/gw.js";
import Firma from "@/components/Firma";
import AddEmail from "@/components/AddEmail";

export default {
  mixins: [gw],
  name: "Info",
  props: {
    desserts: Object
  },
  components: {
    Firma,
    AddEmail
  },
  data: () => ({
    dialogVerificacionAlbaran: false,
    checkboxfirmarprealbaran: true,
    checkboxfirmarprealbaran_disabled: false,
    checkboxenviaremail: true,
    checkboxenviaremail_disabled: false,
    email_list: [],
    email: "",
    observaciones:"",
    edicion: false
  }),
  computed: {
    
  }, 
  watch: {
   firma(){
      this.dialogVerificacionAlbaran = true;
      //this.crearalbaranfromprealbaran();
    },
    desserts() {
      if (this.desserts != null) {
        this.email_list = [
          // ...this.email_list,
          ...(this.desserts.emails || []).map(text => ({
            text,
            selected: false
          })),
          ...(this.desserts.emailsalbaran || []).map(text => ({
            text,
            selected: true
          }))
        ]
      }
    }
  }, 
  mounted() {
    window.info = this;
    console.log(this.desserts);
  },
  methods: {
    updateDesserts(){
      this.api("/peticion/ordentrabajo/edit", this.desserts, false).then(
        resp => {
          if (resp.success == 1) {
            //Todo Ok
            //_this.results_articulo = resp.datos;
            this.toasted("Guardado correctamente", "success", "check");

          }
        },
        err => {
          //this.vista = "pedidoerror";
          console.log(err);
        }
      );
      this.edicion = !this.edicion;
    },
    crearalbaranfromprealbaran(item){
      var filter = {};
      var data = []; data[0] = {};

      //data[0]["prealbaran"] = false; //Crear prealbarán vacio, Si se envía a true no importa nada más.

      //filter["codigo"] = this._routerRoot._route.params.codigo;
      //filter["idprealbaran"] = this.prealbaran.idprealbaran;
      filter["codorden"] = this.desserts.codorden;
      filter["codcliente"] = this.desserts.codcliente;
      //data[0]["codigo"] = this._routerRoot._route.params.codigo;
      //data[0]["idprealbaran"] = this.prealbaran.idprealbaran;
      data[0]["codorden"] = this.desserts.codorden;
      data[0]["codcliente"] = this.desserts.codcliente;
      //data[0]["observaciones"] = this.observaciones;

      //data[0]["albaranar"] = true; //Crear el albaran a partir del prealbaran

      if(this.checkboxenviaremail){//Enviar el albaran firmado, acabado de crear o desde albará indicando el codigo (mismo codigo en prealbaran y albaran)
        //verificamos email o emails
        var emails = [];

        this.email_list.forEach(e => {
          if(e.selected){
              emails.push(e.text);
          }
          
        });
        if(emails.length==0){
          this.toasted("Debe indicar almenos un Email", "error", "error");
          this.dialogVerificacionAlbaran = false;
          //this.$refs.email.focus();
          return true;
        }
        for (let i = 0; i < emails.length; i++){
          if(emails[i]!="" && !this.validarEmail(emails[i])){
            //Si entramos aquí es que hay algún email que es incorrecto
            this.toasted("Hay un Email incorrecto, deseleccionelo y vuelva a intertarlo", "error", "error");
            this.dialogVerificacionAlbaran = false;
            //this.$refs.email.focus();
            return true;
          }
        }
        data[0]["email_envio"] = emails;
      }
      else{
        data[0]["email_envio"] = '';
      }

      if(this.checkboxfirmarprealbaran){
        data[0]["firmadocli"] = true;
        data[0]["firma_dataURL"] = this.firma.dataURL;
        data[0]["firma_nombrefirmante"] = this.firma.nombrefirmante;
      }
      else{
        data[0]["firmadocli"] = false;
        data[0]["firma_dataURL"] = '';
        data[0]["firma_nombrefirmante"] = '';
      }

      this.api("/peticion/finalizarparte/", {'ordenes':{'filter':filter,'data':data}}, true).then(
        resp => {
          if (resp.success == 1) {//Me devuelve algo, Peeero puede devolver un error..
            //Todo Ok
            /* this.setMessage({
              active:true,
              icon:'check_circle',
              coloricon:'#1ca020',
              text:'Se ha creado el Albarán con éxito',
              buttons:[
              {
                text:'Menú principal',
                to:'/'
              },
              {
                text:'Aceptar',
                to:''
              }]
            }); */
            this.toasted("Parte finalizado correctamente", "success", "check");
            //this.to('/ordentrabajo/'+this.desserts.codorden,'rerender');
            this.to('/ordentrabajo/','rerender');

          } else {
            //error
            console.log(resp);
            this.toasted("No se ha podido finalizar el parte", "error", "error");

          }
          // if(resp.success == 1 )  _this.toasted("Se ha " + texto + " al carro corectamente", "success", 'shopping_cart');
          // else _this.toasted("No se ha podido al carro", "error", 'shopping_cart');
        },
        err => {
          this.toasted("No se ha podido finalizar el parte", "error", "error");
          console.log("Error no controlado API");
          console.log(err);
        }
      );
    },
    
  }
};
</script>
